
/*eslint-disable*/
import React, { Suspense, useEffect, lazy } from "react";
import { withRouter } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';
import ContentWrapper from "../../template/Layout/ContentWrapper";
// import Usd_Mxn from './usd_mxn'
const Usd = lazy(() => (import('./usd/index')))


function Usdmxn(props) {
  return (
    <ContentWrapper>
      <div className="content-heading">
        <i
          className='fas fa-wallet mr-2'
        ></i>
        <b>Cost Management</b>
      </div>
      <div>
        <Tab
          menu={{ secondary: true }}
          panes={[
            {
              menuItem: 'USD', render: () => <Suspense fallback={<div>Loading...</div>}>
                <Usd table={'vwInvoiceUSD'} ActiveLoader={false} filters={''} />
              </Suspense>
            },
            {
              menuItem: 'MXN', render: () => <Suspense fallback={<div>Loading...</div>}>
                <Usd table={'vwInvoiceMXN'} ActiveLoader={false} filters={''} />
              </Suspense>
            },
          ]}
        />
      </div>
    </ContentWrapper>
  );
}

export default withRouter(Usdmxn);

